export const ServiceWorkerAppActions = {
  INITIALIZE: "INITIALIZE" as const,
  LAUNCH_SYNC: "LAUNCH_SYNC" as const,
  LAUNCH_BACKGROUND_SYNC: "LAUNCH_BACKGROUND_SYNC" as const,
  CHECK_READY: "CHECK_READY" as const,
} as const;

export const ServiceWorkerAppStateKeys = {
  READY: "READY" as const,
  NOT_READY: "NOT_READY" as const,
  SYNC_REQUIRED: "SYNC_REQUIRED" as const,
  SYNC_COMPLETE: "SYNC_COMPLETE" as const,
  SYNC_ERROR: "SYNC_ERROR" as const,
  LOADED: "LOADED" as const,
} as const;

export const WorkerQueryTransferModes = {
  DEFAULT: "DEFAULT" as const,
  SHARED_ARRAY_BUFFER: "SHARED_ARRAY_BUFFER" as const,
  ARRAY_BUFFER: "ARRAY_BUFFER" as const,
  CHUNKED: "CHUNKED" as const,
} as const;
